import { render, staticRenderFns } from "./adjustmentRecord.vue?vue&type=template&id=2843ce42&scoped=true&"
import script from "./adjustmentRecord.vue?vue&type=script&lang=js&"
export * from "./adjustmentRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2843ce42",
  null
  
)

export default component.exports